import { render, staticRenderFns } from "./CertificateNumberInput.vue?vue&type=template&id=55be4eee&scoped=true&lang=html&"
import script from "./CertificateNumberInput.vue?vue&type=script&lang=js&"
export * from "./CertificateNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be4eee",
  null
  
)

export default component.exports